// src/components/GoogleSignIn.js
import React, { useCallback, useEffect } from "react";
import api from "../interceptors.js";

const GoogleSignIn = ({ onError, onSuccess }) => {
  const handleCallbackResponse = useCallback(
    async (response) => {
      // Decode JWT to get user info
      const base64Url = response.credential.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join(""),
      );
      const user = JSON.parse(jsonPayload);

      console.log("Decoded user info:", user);

      try {
        const res = await api.post(`/api/google-login`, {
          email: user.email,
          name: user.name,
          picture: user.picture,
          sub: user.sub,
        });

        const token = res.data?.access_token || res.data?.token;

        if (token) {
          localStorage.setItem("access_token", token);
          onSuccess?.();
        } else {
          onError?.(res.data?.error || "Google login failed. Please try again.");
        }
      } catch (error) {
        console.error("Error sending data to backend:", error);
        onError?.(
          error.response?.data?.error ||
            error.response?.data?.message ||
            "Something went wrong with Google login.",
        );
      }
    },
    [onError, onSuccess],
  );

  useEffect(() => {
    const initializeGoogle = async () => {
      if (window.google && window.google.accounts) {
        await window.google.accounts.id.initialize({
          client_id:
            "435200404813-g6fc354prjmorulel6k470vta9e74k6b.apps.googleusercontent.com",
          callback: handleCallbackResponse,
        });

        await window.google.accounts.id.renderButton(
          document.getElementById("signInDiv"),
          { theme: "outline", size: "large", width: "300" },
        );
      } else {
        console.error("Google script not loaded yet.");
      }
    };

    initializeGoogle();
  }, [handleCallbackResponse]);

  return (
    <div className="flex justify-center items-center">
      <div id="signInDiv"></div>
    </div>
  );
};

export default GoogleSignIn;
